<template>
  <div class="row">
    <ArtworkImage
      :class="{ 'GTM__modal': !finished }"
      :artwork="artwork"
      @click.native="openModal(index)"
    />
    <div class="col details__desc pt-0">
      <ArtworkHeader
        :class="{ 'GTM__modal': !finished }"
        :artwork="artwork"
        @click.native="openModal(index)"
      />
      <h4 v-if="artwork.date"> {{ I18n.l("date.formats.time", artwork.date) }} </h4>
      <div class="row details__art-desc no-gutters">
        <div class="col-12 col-lg-8">
          <h4 v-if="artwork.artist" class="text--muted">
            {{ artwork.name }}
          </h4>
          <p v-if="artwork.description"
             v-html="artwork.description.substring(0, 230)"
             class="text--muted mb-2">
          </p>
        </div>
        <AuctionHouseName :auctionsCatalog="artwork.auctionsCatalog" />
      </div>
      <FinishedArtworkPriceDetails v-if="finished" :artwork="artwork" />
      <IncomingArtworkPriceDetails v-else :artwork="artwork" :index="index" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { UPDATE_CURRENT_ARTWORK_INDEX } from '../../../store/mutation-types';
  import ArtworkImage from './artwork_image';
  import ArtworkHeader from './artwork_header';
  import ArtworkState from './artwork_state';
  import AuctionHouseName from './auction_house_name';
  import FinishedArtworkPriceDetails from './finished_artwork_price_details';
  import IncomingArtworkPriceDetails from './incoming_artwork_price_details';

  export default {
    name: 'ArtworkDetails',
    components: {
      ArtworkHeader,
      ArtworkState,
      ArtworkImage,
      AuctionHouseName,
      FinishedArtworkPriceDetails,
      IncomingArtworkPriceDetails,
    },
    props: {
      artwork: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
      finished: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['currentArtworkIndex']),
    },
    methods: {
      openModal(currentIndex) {
        this.$store.commit(UPDATE_CURRENT_ARTWORK_INDEX, currentIndex);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/row/artwork_details.vue?8f7c80e8